import { InfusionScreenType } from '../../../constants/infusion-solutions';
import { InfusionDetail } from '../../../interfaces/infusion';
import { DeviceProps } from '../../../interfaces/devices';

interface InfusionsViewerProps {
  currentSpeedInfusion?: number;
  establishmentCode?: string;
  infusionName?: string;
  prescriptionNumber?: string;
  solutionNumber?: string;
}

interface InfusionsSuspendProps {
  infusionDateTime?: string;
  infusionName?: string;
}

interface AdminScheduleProps {
  dilutionDescription?: string;
  dosageTypeDescription?: string;
  observationDescription?: string;
  prescriptionNumber?: number;
  solutionSequenceNumber?: number;
  stepSolutionNumber?: number;
}

export class InfusionsViewerParams {
  static params: InfusionsViewerProps;
  static infusionDetailsParams: InfusionDetail;
  static actionType: string;
  static infusionScreenType: InfusionScreenType;
  static redirectToInfusionSchedule: boolean;
  static realizeFirstChecking: boolean;
  static suspendParams: InfusionsSuspendProps;
  static adminSchedule: AdminScheduleProps;
  static deviceParams: DeviceProps;
}
